<template>
	<div
		class="home-tile"
		:class="[color ? 'tile-color--' + color : '', banner ? 'banner' : '']"
	>
		<div v-if="banner" class="banner-body">
			{{ bannerMessage }}
		</div>
		<div class="tile-text">
			<slot />
		</div>
		<div class="tile-action">
			<slot name="button" v-if="buttonTitle || !!this.$slots['button']">
				<ui-button
					:loading="loading"
					:color="color"
					@click="$emit('click')"
					>{{ buttonTitle }}</ui-button
				>
			</slot>
		</div>
	</div>
</template>

<script>
import UiButton from '@/ui/Button'

export default {
	name: 'home-view',
	props: ['color', 'buttonTitle', 'banner', 'bannerMessage', 'loading'],
	components: { UiButton },
	data() {
		return {}
	},
	methods: {}
}
</script>

<style lang="scss">
.home-tile {
	width: 100%;
	border-radius: 20px;
	padding: 10px;
	margin-bottom: 10px;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
	color: $white;
	text-align: center;
	p,
	h2,
	h3,
	span {
		color: white !important;
	}
	&.tile-color--mint {
		background: $mint;
		h3 {
			color: #fff !important;
		}
	}
	&.tile-color--navy {
		background: $navy;
		h3 {
			color: #fff !important;
		}
	}
	&.tile-color--cerulean {
		background: $cerulean;
		h3 {
			color: #fff !important;
		}
	}
	&.tile-color--pink {
		background: $red;
		h3 {
			color: #fff !important;
		}
	}
	&.tile-color--purple {
		background: $purple;
		h3 {
			color: #fff !important;
		}
	}
	&.tile-color--danger {
		background: $red;
		h3 {
			color: #fff !important;
		}
	}
	.tile-text {
		padding: 25px 0;
	}
	.tile-header {
		text-align: center;
	}
	.tile-image {
		margin-top: -35px;
	}
	span {
		display: block;
		color: $white !important;
		text-align: center;
		&.tile-text-small {
			font-size: $font-size;
		}
		&.tile-text-large {
			font-size: 48px;
		}
	}
	.roundup-button {
		border-radius: 12px;
	}
	.banner {
		padding-top: 2px;
		padding-left: 2px;
		padding-right: 2px;
	}
	.banner-body {
		background: #fff;
		color: $red;
		border-radius: 12px;
		padding: 5px;
	}
}
</style>
